export default __webpack_public_path__ + "static/media/socialWhatsapp.1e4460d3.png";